module.exports = __webpack_public_path__ + "static/media/reverseIcon.ec2e314a.svg";